import Helmet from "react-helmet";
import { Outlet, Route } from "react-router";
import styled, { createGlobalStyle } from "styled-components";

import Applications from "./pages/Applications";
import CreateApplication from "./pages/CreateApplication";
import EditApplication from "./pages/EditApplication";
import AppHeader from "../../components/AppHeader";
import {
    useUnsavedChangesRefs,
    type UnsavedChangesContext,
} from "../../modules/unsaved-changes";

const GlobalStyle = createGlobalStyle`
    :root {
    }
`;

const Styled = styled.div`
    display: grid;
    grid-template-columns: 1fr 3fr;
    gap: 4vw;
    padding: 128px 128px 64px 192px;

    & > *:not(:last-child):not(:hover):not(:has(input:focus)) {
        opacity: .4;
    }
`;

function App() {
    const guard = useUnsavedChangesRefs();

    return (
        <>
            <Helmet>
                <title>Applications</title>
            </Helmet>
            <GlobalStyle />
            <AppHeader title="applications" guard={ guard } />
            <Styled>
                <Outlet context={ guard satisfies UnsavedChangesContext } />
            </Styled>
        </>
    );
}

export default (
    <Route Component={ App } path="applications">
        <Route Component={ Applications }>
            <Route index />
            <Route Component={ CreateApplication } path="new" />
            <Route Component={ EditApplication } path=":applicationDomain" />
        </Route>
    </Route>
);
